import React, { useState } from "react";

const ViewSiteImageModel = ({ isOpenModal, data, onClose }) => {
  const [currentImage, setCurrentImage] = useState(null);

  if (!isOpenModal ) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-end z-50">
      <div className="w-[480px] h-full bg-white p-3 shadow-lg relative flex flex-col">

        <div className="flex items-center justify-between px-3 border-b pb-4">
          <h2 className="text-lg font-semibold">Site Visit Images</h2>
          <button onClick={onClose} className="text-gray-500 p-2 hover:text-gray-800 text-xl">
            &times;
          </button>
        </div>

        <div className="mt-4 flex flex-col gap-4 overflow-y-auto custom-scrollbar px-2 flex-grow">
          {
         data && data.length > 0  ?
          (
          data.map((item, index) => (
            <div key={index} className="flex shadow-md rounded-md p-3 flex-col items-center border-b pb-4">
              <img
                src={item.image[0]}
                alt=""
                className="h-48 object-cover rounded-lg cursor-pointer"
                onClick={() => setCurrentImage(item.image[0])}
              />
              <div className="text-start mt-2 text-gray-700 w-full px-2">
                <div>
                  <span className="font-semibold">{item.propertyName || "Unknown Property"}</span> - {item.visitTime}
                </div>
                <div>By {item.visitGivenBy || "Unknown"}</div>
              </div>
            </div>
          ))
          ):(
            <>
            <div className=" text-center ">No images availble</div>
            </>
          )
        }
        </div>
      </div>


      {currentImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative bg-white p-4 rounded-lg shadow-lg">
            <button
              onClick={() => setCurrentImage(null)}
              className="absolute top-2 right-2 bg-black   rounded-full px-2 py- text-center text-white   text-2xl"
            >
              &times;
            </button>
            <img src={currentImage} alt="Preview" className="max-w-full max-h-[80vh] rounded-lg" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewSiteImageModel;
